import { render, staticRenderFns } from "./CouponDiscount.vue?vue&type=template&id=562ba281&"
import script from "./CouponDiscount.vue?vue&type=script&lang=js&"
export * from "./CouponDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports